import { useMutation } from 'react-query'

import { tfaService } from '@/modules/profile-settings/service/tfa-service.tsx'

export function useGenerateRecoveryCodes() {
  return useMutation(
    'tfa-generate-recovery-codes',
    tfaService.generateRecoveryCodes,
  )
}
